import React, { useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { StylesProvider } from '@material-ui/core/styles';

const GlossaryLink = (props) => {
    const { entry } = props;
    const [tip, setTip] = useState(false);



    const clickHandler = () => {
        setTip(false);
    };
    return (
        <Tooltip open={tip} title={entry.description} onOpen={() => setTip(true)} onClose={() => setTip(false)}>
                <a onClick={clickHandler} href={"/glossary" + encodeURI(("#" + entry.name).toLowerCase())}>{entry.name}</a>
            </Tooltip>
    );
};

export default GlossaryLink;
